<!--
  An invite that arrives while you are on any other page. The Friends page lists
  invites too; dismissing the toast only hides it here.
-->
<script lang="ts">
  import { t } from './i18n.svelte'
  import { friends } from './friends.svelte'
  import { router } from './router.svelte'
  import { watchSharedRoom } from './room-navigation'

  let hidden = $state<number[]>([])

  const invite = $derived(
    friends.invites.find(
      (i) =>
        !hidden.includes(i.at) &&
        !(router.current.name === 'viewer' && router.current.code === i.code),
    ),
  )
</script>

{#if invite}
  <div class="invite-toast" role="alert">
    <span class="invite-toast__text">
      <strong>{t('{name} invited you', { name: invite.name })}</strong>
    </span>
    <button
      type="button"
      class="primary"
      onclick={() => {
        hidden = [...hidden, invite.at]
        watchSharedRoom(invite)
      }}>{t('Join')}</button
    >
    <button type="button" class="ghost" onclick={() => (hidden = [...hidden, invite.at])}
      >{t('Dismiss')}</button
    >
  </div>
{/if}

<style>
  .invite-toast {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 60;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 14px;
    background: var(--bg-raised);
    border: 1px solid var(--border);
    box-shadow: 0 24px 48px -16px rgba(42, 23, 32, 0.45);
  }
</style>
